<template>
  <div class="mt-2" v-if="user.roles && (user.roles.includes('*') || userHasResourceAccess(RESOURCENAMES.API) || userHasResourceAccess(RESOURCENAMES.MANAGEMENT))">
    <v-container style="margin-right: 0; margin-left: 0;">
      <v-row style="height: 100%;" class="pl-2">
        <v-col md="6" class="pr-0">
          <v-toolbar class="mb-3" height="30px" color="#425058" dark>
            <h4>Configure User</h4>
          </v-toolbar>
          <ConfigureUser />
        </v-col>
        <v-col md="6">
          <v-toolbar class="mb-3" height="30px" color="#425058" dark>
            <h4>User Accounts</h4>
          </v-toolbar>
          <UserAccounts :user="getUser" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import UserAccounts from '../components/UserAccounts'
  import ConfigureUser from '../components/ConfigureUser'
  import { mapActions, mapGetters } from 'vuex'
  import { accessControlMixin } from '../components/mixins/index'

  export default {
    mixins:[accessControlMixin],
    data: () => ({ }),
    components: {
      UserAccounts,
      ConfigureUser
    },
    mounted () {
      if (this.user.roles && (!this.user.roles.includes('*') && !this.userHasResourceAccess(this.RESOURCENAMES.API) && !this.userHasResourceAccess(this.RESOURCENAMES.MANAGEMENT))) {
        if (this.$route && this.$route.path !== '/') {
          this.$router.push('/')
        }
      }
    },
    computed: {
      ...mapGetters(['getUser', 'getUserLoggedIn']),
      user () {
        return this.getUserLoggedIn
      }
    },
    async created () {
      await this.getUsers()
    },
    methods: {
      ...mapActions(['getUsers'])
    }
  }
</script>

<style scoped>
  .apiContainer {
    display: flex;
    flex-direction: column;
    height:inherit;
  }

  @media (min-width: 1264px) {
    .container {
      max-width: 100%;
    }
  }
</style>
